enum Employees {
  home= '/employees',
}

export default Employees;
